webpackJsonp([159517907272373],{

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = exports.default = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(6);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Hero = __webpack_require__(9);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Signup = __webpack_require__(64);
	
	var _Signup2 = _interopRequireDefault(_Signup);
	
	var _Row = __webpack_require__(3);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Column = __webpack_require__(4);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _Apply = __webpack_require__(20);
	
	var _Apply2 = _interopRequireDefault(_Apply);
	
	var _CustomHelmet = __webpack_require__(7);
	
	var _CustomHelmet2 = _interopRequireDefault(_CustomHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PressSingle = function (_Component) {
	    _inherits(PressSingle, _Component);
	
	    function PressSingle() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PressSingle);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.setIframeHeightCO = function (ht) {
	            var ifrm = document.getElementsByTagName('iframe')[0];
	
	            ifrm.style.visibility = 'hidden';
	            // some IE versions need a bit added or scrollbar appears
	            ifrm.style.height = ht + "px";
	            ifrm.style.visibility = 'visible';
	        }, _this.handleDocHeightMsg = function (e) {
	            var data = JSON.parse(e.data);
	            _this.setIframeHeightCO(data.docHeight);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    PressSingle.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        window.addEventListener('message', function (message) {
	            message.origin === 'https://en.globalcitizenyear.org' ? _this2.handleDocHeightMsg(message) : null;
	        });
	    };
	
	    PressSingle.prototype.render = function render() {
	        var _props = this.props,
	            data = _props.data,
	            location = _props.location;
	
	        var post = data.post.edges[0].node;
	        return _react2.default.createElement(
	            'div',
	            { className: 'update-single' },
	            _react2.default.createElement(_CustomHelmet2.default, { data: post.yoast_data, fallBack: post, location: location }),
	            _react2.default.createElement(_Hero2.default, { title: post.title }),
	            _react2.default.createElement(
	                _Row2.default,
	                { className: 'contentWrapper capper' },
	                _react2.default.createElement(
	                    _Column2.default,
	                    { style: { margin: '0 auto' }, width: '9', tablet: '12' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: post.content } })
	                    )
	                )
	            )
	        );
	    };
	
	    return PressSingle;
	}(_react.Component);
	
	exports.default = PressSingle;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-press-single-js-174f0c37056f6e55e401.js